<template>
    <div class="clientDetail">
      <!--navBar-->
      <navBar></navBar>
      <!--中间内容部分-->
      <div class="main">
        <div class="mainContainer">
          <div class="nav_detail">
            <span class="nav_back" @click="goBack">案例中心</span> > <span>众安保险</span>
          </div>
          <div class="flex_between">
            <div class="item_left">
              <div class="icon"><i></i></div>
              <p class="title">众安保险</p>
              <div class="intro">
                <div>客户简介</div>
                <p>众安在线财产保险股份有限公司是中国首家互联网保险公司，于2013年11月6日揭牌开业，总部位于上海，不设任何分支机构，完全通过互联网进行在线承保与理赔服务。作为中国首家将核心系统部署在云平台上的金融机构，并将大数据、云计算、区块链、人工智能、物联网等前沿技术深度应用改造保险价值链。</p>
              </div>
              <div class="products">
                <div>使用产品</div>
                <p @click="goProduct('/product2')">渗透测试</p>
                <p @click="goProduct('/product1')">漏洞扫描</p>
              </div>
            </div>
            <div class="item_right">
              <div class="title">
                <i></i>业务背景
              </div>
              <p>众安保险上市期间，在已支付了百万级别安全产品费用后，众安开启上市前最后冲刺阶段的安全评测，经阿里、安恒的两轮满分安全评测后，牛盾在第三轮安全评测中发现问题，为众安上市提供了最后一层安全保障。</p>
              <div class="item_img"><img src="../../assets/img/clientDetail/client2_big.jpg" alt=""></div>
              <div class="title">
                <i></i>解决方案
              </div>
              <p>牛盾网络始终坚信阻止攻击者最好的办法就是像攻击者一样思考和行动。牛盾渗透测试服务就是由专业人员模拟黑客对目标进行攻击以发现目标的脆弱性的服务。针对众安独一无二的网络环境，系统的分析相关应用的脆弱性，量身定制每一次的渗透测试。</p>
              <div class="title">
                <i></i>方案价值
              </div>
              <p>在众安领导的授权下，牛盾在众安公司现场测试发现高危漏洞，该漏洞可造成该公司全部被保人基础信息泄露及保险款项安全最高等级问题产生。经过此次评测，牛盾取得了众安保险的信任与认可，并成为众安保险IPO期间的唯一安全护航合作方。</p>
            </div>
          </div>
        </div>
      </div>
      <!--footerBar-->
      <div class="gw_homefooterBox">
        <footerBar></footerBar>
      </div>
    </div>
</template>

<script>
    import navBar from '../../components/Navbar';
    import footerBar from '../../components/footerbar'
    export default {
      components:{
        navBar,footerBar
      },
      methods:{
        goBack(){
          this.$router.push('/client');
        },
        goProduct(url){
          this.$router.push(url);
          window.scrollTo({top:0});
        }
      }
    }
</script>

<style scoped lang="scss">
   .clientDetail{
     .item_left{
       .icon{
         i{
           width:149px;
           height:32px;
           background:url("../../assets/img/clientDetail/client2_icon.png") no-repeat center;
           background-size:100% 100%;
         }
       }
     }
   }

</style>



// WEBPACK FOOTER //
// src/views/client/client2.vue